module.exports = __webpack_public_path__ + "f4a550e18ac64e8e906002b873cc4c3e.pdf";